'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../_virtual/_tslib.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Item = (props) => {
    const { children } = props, otherProps = _tslib.__rest(props, ["children"]);
    return React__default["default"].createElement("a", Object.assign({}, otherProps), children);
};

exports["default"] = Item;
